var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourTemperments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.71 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.39,4.51c.3,0,.6-.02.91-.02,12.13,0,21.96,9.59,21.96,21.43,0,.82-.05,1.63-.14,2.43-.05.4.03.8.23,1.15l4.4,7.73c.53.92,0,2.07-1.03,2.29l-4.52.94v7.33c0,1.26-1.03,2.29-2.31,2.29h-9.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.11,31.62c1.12,3.97,3.39,7.48,6.43,10.17v16.96h25.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.49,45.97l1.57,1.56c1.63,1.63,3.85,2.55,6.16,2.55"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.8,
    y1: 58.75,
    x2: 38.8,
    y2: 50.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.75,
    y: 0.75,
    width: 25.64,
    height: 37.77
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.65 8.1 7.41 9.87 9.89 7.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 8.62,
    x2: 21.49,
    y2: 8.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.65 15.66 7.41 17.43 9.89 14.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 16.19,
    x2: 21.49,
    y2: 16.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.65 23.23 7.41 24.99 9.89 22.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 23.75,
    x2: 21.49,
    y2: 23.75
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.65 31.1 7.41 32.86 9.89 30.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 31.62,
    x2: 21.49,
    y2: 31.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourTemperments);
export default __webpack_public_path__ + "static/media/four-temperments.9bb7ddbfd48bea63d13393055a521761.svg";
export { ForwardRef as ReactComponent };